// import anime from "animejs/lib/anime.es.js";
import Highway from "@dogstudio/highway";

var newsObject = {
  page: 2,
  loading: false,
  list: $(".js-infinite"),
  loadMore: document.querySelector(".js-load-more"),
  ppp: 4,
};

class News extends Highway.Renderer {
  onEnter() {}
  onEnterCompleted() {
    // common.getScrollbar().addListener(this.loadPosts);
  }

  onLeave() {}

  onLeaveCompleted() {
    newsObject = {};
  }

  /**
   * Load posts by Ajax
   * Only if loadMore element is visible
   */
  loadPosts() {
    if (!updatesObject.loadMore) return;
    // if (!common.getScrollbar().isVisible(updatesObject.loadMore)) return;
    if (!updatesObject.loading) {
      updatesObject.loading = true;

      let data = {
        action: "post_loading",
        page: updatesObject.page,
        ppp: updatesObject.ppp,
        postLoadingNonce: jsArgs.postLoadingNonce,
      };

      $.ajax({
        type: "POST",
        url: jsArgs.url,
        data: data,
        dataType: "json",
        error: function(jqXHR, textStatus, errorThrown) {
          // eslint-disable-line no-unused-vars
          // console.log(jqXHR);
          // console.error("The following error occured: " + jqXHR, textStatus, errorThrown);
        },
        success: function(data) {
          // eslint-disable-line no-unused-vars
          if (data.content !== "") {
            updatesObject.list.append(data.content);
            updatesObject.page++;
            updatesObject.loading = false;
          } else {
            $(updatesObject.loadMore).text("No more items found..");
          }
        },
      });
    }
  }
}

export default News;



// WEBPACK FOOTER //
// ./scripts/routes/news.js